import RelayRenderContainer from './RelayRenderContainer';

export default RelayRenderContainer;
